export const typeRoleAdmin=1;
export const typeRoleClerk=2;
export const typeRolePracticioner=3;
export const typeRoleDefault=4;

export const extraTextClerk = 'De griffier heeft inzage in alle technische vragen. Hij kan de nieuwe technische vragen markeren en doorzetten naar concern. Wanneer de vragen beantwoord zijn kan de griffier de uiteindelijke antwoorden publiceren.';
export const extraTextAdmin = 'De admin kan de notitieservice activeren, de statussen wijzigen, het verdelen van rollen en de deadlines instellen.';
export const extraTextPracticioner = 'De behandelaar heeft inzage in alle technische vragen. Hij kan de technische vragen vanuit \'concern\' naar \'in behandeling\' zetten of van \'in behandeling\' naar \'klaar voor publiceren\'.';

export const tileTextClerk = 'Verplaats vragen van concern en publiceer de antwoorden';
export const tileTextAdmin = 'Beheer instellingen noteservice, wijzigen alle statussen, etc';
export const tileTextPracticioner = 'Beantwoord openstaande vragen en rond deze af';

export const captionClerk = 'Griffier';
export const captionAdmin = 'Admin';
export const captionPracticioner = 'Behandelaar';

export const captionTechnicalQuestionModule = 'Technische vragen module';
export const tileTextTechnicalQuestionModule = 'Wanneer u deze module uitschakelt kunnen er geen nieuwe vragen worden toegevoegd. Reeds gestelde & beantwoorde vragen blijven zichtbaar';
export const captionDeadlineSendingQuestion = 'Deadline insturen technische vragen';
export const tileTextDeadlineSendingQuestion = 'Tot deze datum kunnen nieuwe technische vragen worden aangemaakt';
export const captionDeadlineAnsweringQuestion = 'Deadline beantwoording vraag';
export const tileTextDeadlineAnsweringQuestion = 'Uiterlijk deze datum moeten technische vragen beantwoord zijn';

export const captionFactionFunctionality = 'Vragen alleen zichtbaar voor de fractie';
export const tileTextFactionFunctionality = 'Standaard zijn alle technische vragen voor iedereen zichtbaar. Wanneer u de fractie functionaliteit inschakelt zijn de technische vragen alleen zichtbaar binnen een fractie.';



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/admin/adminText.tsx